import { useRef, useEffect, useState } from 'react';
import { Node } from 'modules/workflows/types';
import { EdgeModel } from 'ui/workflows/flowchart/types';
import { JourneyPreview } from '../JourneyPreview';
import { PreviewContainer, SelectedRevisionPreview, PreviewWrapper, NoData } from './styles';

export type RevisionPreviewProps = {
  nodes: Node[];
  edges: EdgeModel[];
};

export const SELECTED_REVISION_PREVIEW_NONE_ID = 'selected-revision-preview-none';
export const SELECTED_REVISION_PREVIEW_ID = 'selected-revision-preview';

export const RevisionPreview = ({ nodes = [], edges = [] }: RevisionPreviewProps) => {
  const journeyPreviewRef = useRef<HTMLInputElement>(null);
  const [width, setWidth] = useState(journeyPreviewRef?.current?.offsetWidth);
  const [height, setHeight] = useState(journeyPreviewRef?.current?.offsetHeight);

  useEffect(() => {
    if (journeyPreviewRef?.current) {
      setWidth(journeyPreviewRef?.current?.offsetWidth);
      setHeight(journeyPreviewRef?.current?.offsetHeight);
    }
  }, [
    journeyPreviewRef?.current,
    journeyPreviewRef?.current?.offsetWidth,
    journeyPreviewRef?.current?.offsetHeight,
  ]);

  return (
    <PreviewContainer>
      <SelectedRevisionPreview>
        {nodes?.length ? (
          <PreviewWrapper
            id="revision-preview"
            ref={journeyPreviewRef}
            data-test={SELECTED_REVISION_PREVIEW_ID}
          >
            <JourneyPreview
              nodes={nodes}
              edges={edges}
              width={width && width}
              height={height && height}
            />
          </PreviewWrapper>
        ) : (
          // there should always be at least one node but in order to catch any potential errors
          <NoData data-test={SELECTED_REVISION_PREVIEW_NONE_ID}>No preview is available.</NoData>
        )}
      </SelectedRevisionPreview>
    </PreviewContainer>
  );
};
